import { extend, override } from 'flarum/common/extend';

import BlogItemSidebar from 'flarum/v17development/blog/components/BlogItemSidebar';
import BlogOverview from 'flarum/v17development/blog/pages/BlogOverview';

import type ItemList from 'flarum/common/utils/ItemList';

export default function hideBlogForumNav() {
  BlogItemSidebar &&
    extend(BlogItemSidebar.prototype, 'items', function render(this: BlogItemSidebar, items: ItemList) {
      items.remove('categories');
      items.remove('nav');
    });

  BlogOverview &&
    extend(BlogOverview.prototype, 'oninit', function render(this: BlogOverview) {
      this.showForumNav = false;
      this.showCategories = false;
    });

  if (!BlogItemSidebar || !BlogOverview) {
    console.trace('[B-MAG] Blog items not imported!');
  }
}
